import React, { useEffect, useRef, useState } from "react";
import { formatDate, startLoader, stopLoader } from "../../../lib/utils";
import flatpickr from "flatpickr";
// import config from "../../../config";
import client from "../../../clients";
import Toast from '../../../lib/toast'
import { changeInvoiceDate } from "../helper/api";
import { isAuthenticated } from "../../../auth";

const ChangeInvoice = (props) => {
  const payment = props.payment;
  const changeInvoiceDateRef = useRef(null);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [currentElementId, setCurrentElementId] = useState();
  const [isButtonLock,setButtonLock] = useState(true);
  const {user,token} = isAuthenticated();
  const [reason,setReason] = useState('');

  const handleReason = event => setReason(event.target.value);

  const toggleInputFields = (id) => {
    setCurrentElementId(id);
  }

  const ChangeInvoiceDate = async event =>{
    try{
      await startLoader()
      setButtonLock(true)


      const payload = {
        invoiceDate:invoiceDate,
        reason
      }


      const response = await changeInvoiceDate(user._id,token,payment._id,payload);
      if(response.error){
        new Toast({
          type:'error',
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:'success',
          duration:3000,
          message:"Invoice Date changed sucessfully"
        })
        props.handleCloseModal("change-invoice-date")
        props.reload();
      }

    }catch(error){
        new Toast({
          type:'error',
          duration:3000,
          message:error
        })
    }
    await stopLoader()
    setButtonLock(false)
  }

  const openInvoiceDateAndTime = () => {

    if (!changeInvoiceDateRef.current) return;

    const InvoiceDatePicker = flatpickr(changeInvoiceDateRef.current, {
      disableMobile: true,
      dateFormat: "Y-m-d",
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setInvoiceDate(istDate)
      }
    });
  
    return () => {
      InvoiceDatePicker.destroy();
    }
  }

  useEffect(() => {
    if(currentElementId == "changed-invoice-date"){
      openInvoiceDateAndTime();
    }
  },[currentElementId])

  useEffect(()=>{
    if(invoiceDate && reason){
      setButtonLock(false)
    }else{
      setButtonLock(true)
    }
  },[invoiceDate,reason])

  if(!payment) return <></>;

  return(
    <div className={window.innerWidth < 768 ? "w-full h-full" : "modal-test-container d-flex"}>
      <div className={window.innerWidth < 768 ? "w-full h-full" : "change-invoice-date-modal slideBottomToTop flex-item"}>
        {
          window.innerWidth > 767 && (
            <div className="modal-header space-between" style={{height:"64px", background:"var(--darkBlue)"}}>
              <p className="flex-item fs-18 font-weight-700 color-white">Invoice Date</p>
              <div onClick={()=>props.handleCloseModal("change-invoice-date")} className="d-flex desktop-modal-close-button flex-item" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div style={{padding:"12px"}}>
          <p className="fs-14 font-weight-600 m-b-12">Changing Invoice date for:</p>
          <div className="d-flex space-between m-b-20">
            <div className="d-flex flex-item">
              {/* <div className="invoice-day-user-profile d-flex">
                <img className="flex-item" src={"https://picsum.photos/200/300"} />
              </div> */}
              {
                  (payment.user[0].profileID) ?
                      <div className='invoice-day-user-profile d-flex'>
                        <img className="flex-item" src={`${client.config.API_URL}/image/file/${payment.user[0].profileID}/30/30/70?${Date.now()}`} loading='lazy' />
                      </div>
                      : <div className='invoice-day-user-profile d-flex' style={{
                        backgroundColor: "#5d883c"
                      }}>
                        <p className='flex-item' style={{
                          color: "#ffffff",
                          margin: "0 auto",
                          fontSize: 14,
                        }}>{`${payment.user[0].name}`.trim()[0]}</p>
                      </div>
                  
              }
              <div className="flex-item m-l-8">
                <p className="fs-16 color-dark-blue font-weight-600" style={{lineHeight:"16px"}}>{payment.user[0].name}</p>
                <p className="color-grey-02 fs-12 m-t-2">{payment.user[0].phone}</p>
              </div>
            </div>
            <div className="flex-item m-l-8 flex-item" style={{textAlign:"right"}}>
              <p className="fs-12" style={{lineHeight:"16px"}}>Invoice Number</p>
              <p className="m-t-2 color-red font-weight-700">{payment.invoice_number}</p>
            </div>
          </div>
          <div onClick={()=>toggleInputFields("changed-invoice-date")} className={`${currentElementId == "changed-invoice-date" || invoiceDate ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: (currentElementId == "changed-invoice-date" || invoiceDate) ? "1px solid var(--darkBlue)" : "", width:"100%"}}>
            <div className="flex-item d-flex" style={{marginTop: (currentElementId == "changed-invoice-date" || invoiceDate) ? "4px" : ""}}>
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "changed-invoice-date" || invoiceDate) ? "12px" : "16px", lineHeight: (currentElementId == "changed-invoice-date" || invoiceDate) ? "12px" : "14px", color: (currentElementId == "changed-invoice-date" || invoiceDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Invoice Date</p>
            </div>
            <input id="changed-invoice-date" ref={changeInvoiceDateRef} value={invoiceDate ?  formatDate(new Date(invoiceDate)) : ""} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'changed-invoice-date' || invoiceDate) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder='YYYY-MM-DD' />
          </div>
          <div onClick={()=>toggleInputFields("reason")} className={`${currentElementId == "reason" || reason ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12 m-t-16`} style={{ border: (currentElementId == "reason" || reason) ? "1px solid var(--darkBlue)" : "", width:"100%"}}>
            <div className="flex-item d-flex" style={{marginTop: (currentElementId == "reason" || reason) ? "4px" : ""}}>
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "reason" || reason) ? "12px" : "16px", lineHeight: (currentElementId == "reason" || reason) ? "12px" : "14px", color: (currentElementId == "reason" || reason) ? "var(--darkBlue)" : "", transition: "180ms" }}>Reason*</p>
            </div>
            <input id="reason" onInput={handleReason} value={reason ?  reason : ""} style={{color: "#2b2b2b"}} className={`${(currentElementId == 'reason' || reason) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder='Write Reason....' />
          </div>
          <div onClick={isButtonLock?null:ChangeInvoiceDate} className={`member-button-global ${isButtonLock? 'member-button-global-inactive' : ''} btn-center d-flex flex-item m-t-20 button-red`} style={{width:"100%",pointerEvents:!isButtonLock?'auto':'none'}}>
            <p className='flex-item font-weight-600' style={{fontSize:"16px"}}>Change Invoice Date</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangeInvoice;